import { formatCurrency, formatInteger } from '@/utils/numberFormat';
import { formatDateShort } from '@/utils/datePresentation';
import { SUPPLIERS_TEXT } from '@/texts/catalog/suppliers';
import { extractPayload } from '@/utils/dataNormalization';

const toNumber = (value, defaultValue = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : defaultValue;
};

export const createInitialSuppliersMetricsValues = () => ({
  total_suppliers: 0,
  pending_expenses: 0,
  paid_expenses: 0,
  latest_supplier: {
    id: 0,
    name: '',
    created_at: '',
  },
});

export const mapSuppliersMetricsPayload = (payload) => {
  const latestSupplier = payload?.latest_supplier && typeof payload.latest_supplier === 'object'
    ? payload.latest_supplier
    : {};

  return {
    total_suppliers: toNumber(payload?.total_suppliers, 0),
    pending_expenses: toNumber(payload?.pending_expenses, 0),
    paid_expenses: toNumber(payload?.paid_expenses, 0),
    latest_supplier: {
      id: toNumber(latestSupplier?.id, 0),
      name: String(latestSupplier?.name || '').trim(),
      created_at: String(latestSupplier?.created_at || '').trim(),
    },
  };
};

export const fetchSuppliersMetricsPayload = async (suppliersService, params = {}) => {
  const response = await suppliersService.metrics(params);
  const payload = extractPayload(response);
  const root = payload && typeof payload === 'object' && payload.data && typeof payload.data === 'object'
    ? payload.data
    : payload;

  return mapSuppliersMetricsPayload(root || {});
};

export const buildSuppliersKpiCards = (metricsValues) => {
  const latestSupplierName = String(metricsValues?.latest_supplier?.name || '').trim() || SUPPLIERS_TEXT.metrics.latestSupplierEmpty;
  const latestSupplierCreatedAt = String(metricsValues?.latest_supplier?.created_at || '').trim();
  const latestSupplierId = Number(metricsValues?.latest_supplier?.id || 0);
  const latestSupplierRoute = latestSupplierId > 0
    ? { name: 'supplierDetail', params: { supplierId: latestSupplierId } }
    : null;
  const latestSupplierMeta = latestSupplierCreatedAt !== ''
    ? `${SUPPLIERS_TEXT.metrics.latestSupplierMetaPrefix} ${formatDateShort(latestSupplierCreatedAt)}`
    : '';

  return [
    {
      title: SUPPLIERS_TEXT.metrics.totalSuppliers,
      value: formatInteger(metricsValues?.total_suppliers),
      icon: 'fa-truck',
      iconBg: 'rgba(0, 112, 205, 0.12)',
      iconColor: '#0070cd',
    },
    {
      title: SUPPLIERS_TEXT.metrics.pendingExpenses,
      value: formatCurrency(metricsValues?.pending_expenses),
      icon: 'fa-clock-o',
      iconBg: 'rgba(255, 152, 0, 0.14)',
      iconColor: '#f59e0b',
    },
    {
      title: SUPPLIERS_TEXT.metrics.paidExpenses,
      value: formatCurrency(metricsValues?.paid_expenses),
      icon: 'fa-check',
      iconBg: 'rgba(34, 197, 94, 0.14)',
      iconColor: '#16a34a',
    },
    {
      title: SUPPLIERS_TEXT.metrics.latestSupplier,
      value: latestSupplierName,
      valueRoute: latestSupplierRoute,
      valueLinkClass: 'kpi-value-link-customer',
      valueMeta: latestSupplierMeta,
      truncateValue: true,
      valueScale: 0.5625,
      icon: 'fa-user-plus',
      iconBg: 'rgba(1, 191, 210, 0.12)',
      iconColor: '#01bfd2',
    },
  ];
};
